<template id="Go">
	<div>
		<div v-show="this.pay.loading" class="loading_pay"> 
			
			Vous avez initié une demande de paiement <br><br>
			{{pay.error_msg}}<br><br>
			<span v-show="show_loader()" class="lds-dual-ring loader_pay"></span>
		</div>
				<!-- <div class="btn_command_div">
					<button  @click="remplir_test()" class="btn_command fade-in fade-out">REMPLIR TEST</button>
				</div> -->


		<div class="page">
			<div id="page1" v-show="!this.pay.hide_inputs"class="page1" v-bind:class="{page1resp:this.$store.state.vehicule.send.type==2}">
				<div v-show="show_vehicule()" class="div_vehicule fade-in fade-out">
					<Vehicule class="component" id="Go"/>
					<div id="tarif" v-show="errors_misiv()" class="tarif">
						<div class="tarif_title fade-in fade-out"><h3>Prix de votre carte grise : {{this.$store.state.vehicule.TaxeTotale}}<span v-show="show_loader()" class="lds-dual-ring"></span> €</h3>
							<h4>{{this.$store.state.vehicule.demarche.txt}}</h4>
						</div>
						<div v-show="show_loader()" class="loader2">
							<span class="lds-dual-ring"></span>
						</div>
						<div v-show="show_informations()" class="informations">
							<div class="information">
								<p>Taxe Regionale : {{this.$store.state.vehicule.TaxeRegionale}} €</p>
								<p>Taxe 35cv : {{this.$store.state.vehicule.Taxe35cv}} €</p>
								<p>Taxe Parafiscale : {{this.$store.state.vehicule.TaxeParafiscale}} €</p>
								<p>Taxe CO2 : {{this.$store.state.vehicule.TaxeCO2}} €</p>
							</div class='information'>
							<div>
								<p>Malus : {{this.$store.state.vehicule.TaxeMalus}} €</p>
								<p>Taxe SIV : {{this.$store.state.vehicule.TaxeSIV}} €</p>
								<p>Redevance SIV : {{this.$store.state.vehicule.TaxeRedevanceSIV}} €</p>
								<p>Frais de Dossier : {{this.$store.state.vehicule.Prestation}} €</p>
							</div>
						</div>
							<div v-show="show_informations()" class="total">
								<p><strong> Montant total : {{this.$store.state.vehicule.PrixTotal}} €</strong></p>
							</div>
						
					</div>
					<div>
						<button v-show="!this.$store.state.vehicule.show_form_command&&!show_loader()" @click="command()" class="btn_command fade-in fade-out">{{this.$store.state.vehicule.send.text}}</button>
					</div>
				</div>
				<div v-show="show_simulateur()" class="div_simulateur">
					<Simulateur class="component"id="Go_simulateur"/>
				</div>
			</div>
			<div id="page2" class="page2" v-bind:class="{page2resp:this.$store.state.vehicule.send.type==2}">
				<div v-show="!this.$store.state.vehicule.show_form_command&&!this.pay.hide_inputs" class='home_infos fade-in fade-out'>
					<!-- <h2>Notre Agence de Sète (34200)</h2> -->
					<div>
						<span class="material-icons md-36 md-blue">calculate</span>
	  					<p>Je calcule le prix de ma carte grise en fonction de mon véhicule et de la démarche choisie</p>
					</div>
					<span class="material-icons md-36 md-blue arrow">keyboard_arrow_down</span>
					<div>
						<span class="material-icons md-36 md-blue">credit_card</span>
	  					<p>Je règle le montant total (taxes d'immatriculation + frais de dossier) par carte bleue de manière totalement sécurisée</p>
					</div>
					<span class="material-icons md-36 md-blue arrow">keyboard_arrow_down</span>
	  				<div>
	  					<span class="material-icons md-36 md-blue">outgoing_mail</span>
	  					<p>J'accède à mon espace dédié et je transmets les pièces justificatives nécessaires au traitement de mon dossier</p>
	  				</div>
	  				<span class="material-icons md-36 md-blue arrow">keyboard_arrow_down</span>
	  				<div>
	  					<span class="material-icons md-36 md-blue">watch_later</span>
			      		<p>A récèption de toutes les pièces justificatives, mon dossier est traité sous 24h et je reçois un accusé d'enregistrement par mail</p>
	  				</div>
	  				<span class="material-icons md-36 md-blue arrow">keyboard_arrow_down</span>
	  				<div>
	  					<span class="material-icons md-36 md-blue">local_shipping</span>
			      		<p>Ma carte grise est expédiée directement chez moi en lettre suivie contre signature sous 48h environ (délais postaux moyens)</p>
	  				</div>
				</div>
				<div v-show="this.pay.show_inputs">
					<h1>Bonjour {{this.name.value}}, bienvenue sur votre page de paiement</h1>
					<h2>{{pay.demarche}} - {{pay.immat}} - {{pay.amount}} €</h2>
				</div>
				<div v-show="this.$store.state.vehicule.show_form_command&&!this.show_iframe||this.pay.show_inputs" class="form_command fade-in fade-out">
					<p v-if="sexe.error" class="error_txt">{{this.sexe.txt}}</p>
					<p v-if="name.error" class="error_txt">{{this.name.txt}}</p>
						<p v-if="naissance.error" class="error_txt">{{this.naissance.txt}}</p>
						<p v-if="phone.error" class="error_txt">{{this.phone.txt}}</p>
						<p v-if="mail.error" class="error_txt">{{this.mail.txt}}</p>
						<p v-if="adresse.error" class="error_txt">{{this.adresse.txt}}</p>
						<p v-if="cp.error" class="error_txt">{{this.cp.txt}}</p>
						<p v-if="ville.error" class="error_txt">{{this.ville.txt}}</p>
						<p v-if="name_cb.error" class="error_txt">{{this.name_cb.txt}}</p>
						<p v-if="first_name_cb.error" class="error_txt">{{this.first_name_cb.txt}}</p>
					
							<div v-if="!this.pay.hide_inputs" class="radios">
									<div class="radio">
										<div>
											<input id="Homme" name="type" type="radio" value="Homme" v-model="sexe.value" >
											<label for="Homme" class="label" v-bind:class="{error_input:sexe.error}">Monsieur</label>
										</div>
										<div>
											<input id="Femme" name="type" type="radio" value="Femme" v-model="sexe.value">
											<label for="Femme" class="label" v-bind:class="{error_input:sexe.error}">Madame</label>
										</div>
										<div>
											<input id="Entreprise" name="type" type="radio" value="Entreprise" v-model="sexe.value">
											<label for="Entreprise" class="label" v-bind:class="{error_input:sexe.error}">Société, entreprise en nom propre, association...</label>
										</div>
									</div>
							</div>
							<div class="inputs">
						<div class="inputs1">
							<div v-if="!this.pay.hide_inputs" class="input">
								<label v-if="this.sexe.value=='Homme'||this.sexe.value=='Femme'||this.sexe.value==''" for="name" class="label">Nom et Prénom</label>
								<label v-if="this.sexe.value=='Entreprise'" for="name" class="label">Raison Sociale</label>
								<input v-model="name.value" @change="split_name" id="name" name="name" type="text" class="simu-input immat-imput" v-bind:class="{error_input:name.error}">
							</div>
							<div v-if="!this.pay.hide_inputs&&(this.sexe.value=='Homme'||this.sexe.value=='Femme')" class="input">
								<label for="naissance" class="label">Date de Naissance</label>
								<input v-model="naissance.value" id="naissance" name="naissance" type="date" class="simu-input immat-imput" v-bind:class="{error_input:naissance.error}">
							</div>
							<div v-if="!this.pay.hide_inputs" class="input">
								<label for="phone" class="label">Numéro de téléphone</label>
								<input v-model="phone.value" id="phone" name="phone" type="tel" minlength="10" maxlength="12" class="simu-input error-input" v-bind:class="{error_input:phone.error}">
							</div>
							<div v-if="!show_iframe" class="input">
								<label for="mail" class="label">Adresse mail</label>
								<input v-model="mail.value" id="mail" name="mail" type="text" class="simu-input immat-imput" v-bind:class="{error_input:mail.error}">
							</div>

							<!-- <div v-if="!show_iframe" class="input">
								<label for="name_cb" class="label">Nom (figurant sur la carte bleue)</label>
								<input v-model="name_cb.value" id="name_cb" name="name_cb" type="text" class="simu-input error-input" v-bind:class="{error_input:name_cb.error}">
							</div>
							<div v-if="!show_iframe" class="input">
								<label for="first_name_cb" class="label">Prénom (figurant sur la carte bleue)</label>
								<input v-model="first_name_cb.value" id="first_name_cb" name="first_name_cb" type="text" class="simu-input error-input" v-bind:class="{error_input:first_name_cb.error}">
							</div> -->

						</div>
						<div class="inputs2">
							<div v-if="!show_iframe" class="input">
								<label for="adresse" class="label">Adresse postale</label>
								<input v-model="adresse.value" id="adresse" name="adresse" type="text" class="simu-input immat-imput" v-bind:class="{error_input:adresse.error}">
							</div>
							<div v-if="!show_iframe" class="input">
								<label for="cp" class="label">Code Postal</label>
								<input v-model="cp.value" id="cp" name="cp" type="text" class="simu-input immat-imput" v-bind:class="{error_input:cp.error}">
							</div>
							<div v-if="!show_iframe" class="input">
								<label for="ville" class="label">Ville</label>
								<input v-model="ville.value" id="ville" name="ville" type="text" class="simu-input immat-imput" v-bind:class="{error_input:ville.error}">
							</div>
						</div>
						
						
					</div>
					<div class="inputs">
						<div class="inputs1">
							<div v-if="!show_iframe" class="input">
								<label for="name_cb" class="label">Nom (figurant sur la carte bleue)</label>
								<input v-model="name_cb.value" id="name_cb" name="name_cb" type="text" class="simu-input error-input" v-bind:class="{error_input:name_cb.error}">
							</div>
						</div>
						<div class="inputs2">
							<div v-if="!show_iframe" class="input">
								<label for="first_name_cb" class="label">Prénom (figurant sur la carte bleue)</label>
								<input v-model="first_name_cb.value" id="first_name_cb" name="first_name_cb" type="text" class="simu-input error-input" v-bind:class="{error_input:first_name_cb.error}">
							</div>
						</div>
					</div>
				</div>
				<div v-show="this.$store.state.vehicule.show_form_command&&!show_iframe" class="btn_command_div">
					<button  @click="command()" class="btn_command fade-in fade-out">{{this.$store.state.vehicule.send.text}}</button>
				</div>
				<div v-show="pay.show_inputs&&!show_iframe" class="btn_command_div">
					<button  @click="pay_out()" class="btn_command fade-in fade-out">Procéder au paiement</button>
				</div>
				<div v-show="show_iframe" class="iframe_div fade-in fade-out">
					<!-- A CACHER POUR PRODUCTION -->
<!-- 					<form ref="f22" method="POST" action="https://preprod-tpeweb.e-transactions.fr/php/" target="my_iframe">
						<input type="hidden" name="PBX_SITE" value="3212482">
						<input type="hidden" name="PBX_RANG" value="001">
						<input type="hidden" name="PBX_IDENTIFIANT" value="32429071">
						<input type="hidden" name="PBX_SOURCE" value="RWD">
						<input type="hidden" name="PBX_TOTAL" :value="this.$store.state.vehicule.payment.amount">
						<input type="hidden" name="PBX_DEVISE" value="978">
						<input type="hidden" name="PBX_CMD" :value="this.$store.state.vehicule.payment.ref">
						<input type="hidden" name="PBX_PORTEUR" :value="mail.value">
						<input type="hidden" name="PBX_TYPEPAIEMENT" value="CARTE">
						<input type="hidden" name="PBX_TYPECARTE" value="CB">
						<input type="hidden" name="PBX_RETOUR" value="Mt:M;Ref:R;Auto:A;Erreur:E;sign:K">
						<input type="hidden" name="PBX_HASH" value="SHA512">
						<input ref="f22date" type="hidden" name="PBX_TIME" value="">
						<input ref="f22shop" type="hidden" name="PBX_SHOPPINGCART" value="">
						<input ref="f22bill" type="hidden" name="PBX_BILLING" value=""> 
						<input ref="f22hmac" type="hidden" name="PBX_HMAC" value="">
					</form> -->

					<!-- A ACTIVER POUR PRODUCTION -->
					<form ref="f22" method="POST" action="https://tpeweb.e-transactions.fr/cgi/FramepagepaiementRWD.cgi" target="my_iframe">
						<input type="hidden" name="PBX_SITE" value="3212482">
						<input type="hidden" name="PBX_RANG" value="001">
						<input type="hidden" name="PBX_IDENTIFIANT" value="32429071">
						<input type="hidden" name="PBX_SOURCE" value="RWD">
						<input type="hidden" name="PBX_TOTAL" :value="this.$store.state.vehicule.payment.amount">
						<input type="hidden" name="PBX_DEVISE" value="978">
						<input type="hidden" name="PBX_CMD" :value="this.$store.state.vehicule.payment.ref">
						<input type="hidden" name="PBX_PORTEUR" :value="mail.value">
						<input type="hidden" name="PBX_TYPEPAIEMENT" value="CARTE">
						<input type="hidden" name="PBX_TYPECARTE" value="CB">
						<input type="hidden" name="PBX_RETOUR" value="Mt:M;Ref:R;Auto:A;Erreur:E;sign:K">
						<input type="hidden" name="PBX_HASH" value="SHA512">
						<input ref="f22date" type="hidden" name="PBX_TIME" value="">
						<input ref="f22shop" type="hidden" name="PBX_SHOPPINGCART" value="">
						<input ref="f22bill" type="hidden" name="PBX_BILLING" value=""> 
						<input ref="f22hmac" type="hidden" name="PBX_HMAC" value="">
					</form>
					
					<iframe id="iframe_callback" name="my_iframe" src="" width="500px" height="650px" class="iframe" scrolling="no"></iframe>
				</div>
			</div>
		</div>
		<div>

		</div>
	</div>
</template>

<script>
const fb = require('../../firebaseConfig.js')
const crypto = require('crypto');
import Vehicule from '../Vehicule.vue'
import Simulateur from '../Simulateur.vue'
import firebase from 'firebase'
import emailjs from '@emailjs/browser';
export default {
	components:{Vehicule,Simulateur},
	name: 'Immatriculation',
	data () {
		return {
			sexe:{
				value:"",
				error:false,
				txt:""
			},
			name:{
				value:"",
				error:false,
				txt:""
			},
			name_cb:{
				value:"",
				error:false,
				txt:""
			},
			first_name_cb:{
				value:"",
				error:false,
				txt:""
			},
			phone:{
				value:"",
				error:false,
				txt:""
			},
			mail:{
				value:"",
				error:false,
				txt:""
			},
			naissance:{
				value:"",
				error:false,
				txt:""
			},
			adresse:{
				value:"",
				error:false,
				txt:""
			},
			cp:{
				value:"",
				error:false,
				txt:""
			},
			ville:{
				value:"",
				error:false,
				txt:""
			},
			pay:{
				hide_inputs:false,
				show_inputs:false,
				loading:false,
				demarche:"",
				immat:"",
				amount:"",
				id:"",
				error_msg:""
			},
			show_iframe:false,
			//key:'5E627792D0AFE37861927617F8C2C20CBC0739BBB09C66FC87EE2E67343D011B599192BFC806223AC105F2710A1B5EC093FA54300C6EF0A4B6A801D5B879FB57',
			key_test:'599192BFC806223AC105F2710A1B5EC093FA54300C6EF0A4B6A801D5B879FB57',
			key:'74245F69B485BF5C78E04BC1BE38F1F4B003ED001EB403CE008D364BA60E4127',
			ref:"",
			date:"",
			hmac:"",
			amount:"",
			callback:"https://flow.zoho.eu/20066505919/flow/webhook/incoming?zapikey=1001.07cc3604bcfc0688600f2919b4af5821",
			// callback_:"",
			//callback_test:"https://flow.zoho.eu/20066505919/flow/webhook/incoming?zapikey=1001.dbfcb90232b7aa6d86649333fe9d6e3b.adc1bb95e902ff2eebcdb2a18a182aaa&isdebug=true",
		}
	},
	methods:{
		// get_callback(){
		// 	return firebase.auth().signInAnonymously()
  //     		.then(() => {
		// 		return fb.db.collection('paiements').doc("credit_agricole").get().then(cr_agr => {
		// 			//console.log(cr_agr.data().callback)
		// 			this.callback_=cr_agr.data().callback;
		// 			return true;
		// 		});
		// 	});
		// },
		
		//
		/*
		remplir_test(){
			this.sexe.value="Homme";
			this.name.value="BAPTISTA MANUEL";
			this.naissance.value="1996-07-01";
			this.mail.value="baptista.m34@gmail.com";
			this.phone.value="0646625188";
			this.adresse.value="11 RUE PERIDIER";
			this.ville.value="SETE";
			this.cp.value = "34200";
			this.name_cb.value="BAPTISTA";
			this.first_name_cb.value="MANUEL";
		},
		*/
		//

		escapeHtml(text) {
			var map = {
			    '&': '&amp;',
			    '<': '&lt;',
			    '>': '&gt;',
			    '"': '&quot;',
			    "'": '&#039;'
			  };
		  return text.replace(/[&<>"']/g, function(m) { return map[m]; });
		},
		split_name(e){
			//console.log("CHANGE");
			var name_value = e.target.value;
			this.name_cb.value=name_value.split(" ")[0];
			this.first_name_cb.value=name_value.split(" ")[1];
		},
		split_name_f(name_value){
			this.name_cb.value=name_value.split(" ")[0];
			this.first_name_cb.value=name_value.split(" ")[1];
		},
		errors_misiv(){
			if(Object.keys(this.$store.state.vehicule.errors).length>0){
				//console.log(Object.keys(this.$store.state.vehicule.errors))
				return false;
			}else{
				return true;
			}
		},
		show_vehicule(){
			return this.$store.state.vehicule.completed;
		},
		show_simulateur(){
			return !this.$store.state.vehicule.completed;
		},
		show_loader(){
			if(this.$store.state.vehicule.TaxeTotale==""){
				return true;
			}
		},
		show_informations(){
			if(this.$store.state.vehicule.TaxeTotale!=""){
				return true;
			}
		},
		control_inputs(){
			var re_nom = /^[A-Z0-9 ,.'-]+$/;
			var re_tel = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
			var re_mail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
			var re_cp = /^\d{2}\d{3}$/;
			var re_adresse = /^[a-zA-Z0-9\s,'-]*$/;
			var re_ville = /^[a-zA-Z\s,'-]*$/;
			var errors = [];
			var result = true;
			this.name.value = this.name.value.toUpperCase();
			this.cp.value = this.cp.value.split(" ").join("");
			this.adresse.value = this.adresse.value.toUpperCase();
			this.ville.value = this.ville.value.toUpperCase();
			this.name_cb.value = this.name_cb.value.toUpperCase();
			this.first_name_cb.value = this.first_name_cb.value.toUpperCase();
			if(!re_nom.test(this.name.value)){
				errors.push("name");
			}
			if(!re_nom.test(this.name_cb.value)){
				errors.push("name_cb");
			}
			if(!re_nom.test(this.first_name_cb.value)){
				errors.push("first_name_cb");
			}
			if(!re_tel.test(this.phone.value)){
				errors.push("phone");		
			}
			if(!re_mail.test(this.mail.value)){
				errors.push("mail");		
			}
			if(!re_cp.test(this.cp.value)){
				errors.push("cp");		
			}
			if(!re_adresse.test(this.adresse.value)){
				errors.push("adresse");		
			}
			if(!re_ville.test(this.ville.value)){
				errors.push("ville");		
			}
			return {errors:errors};
		},
		go(){
			var go = true;

			if(this.sexe.value == ""){
				//console.log("OK")
				this.sexe.error=true;
				this.sexe.txt="Veuillez renseigner si vous êtes une personne physique (homme ou femme) ou bien une personne morale (société, entreprise en nim propre, association...)";
				go=false;
			}else{
				this.sexe.error=false;
			}
			//console.log(this.sexe.value);
			var control_inputs = this.control_inputs();
			if(this.name.value == ""){
				this.name.error=true;
				this.name.txt="Veuillez saisir votre Nom et votre Prénom";
				go=false;
			}else{
				if(control_inputs.errors.includes("name")){
					this.name.error=true;
					this.name.txt="Veuillez saisir un Nom et/ou un Prénom (ou Raison Sociale si vous êtes une entreprise) correct (sans caractères accentués ou caractères spéciaux)";
					go=false;
				}else{
					this.name.error=false;
				}
			}
			if(this.phone.value == ""){
				this.phone.error=true;
				this.phone.txt="Veuillez saisir votre numéro de téléphone";
				go=false;
			}else{
				if(control_inputs.errors.includes("phone")){
					this.phone.error=true;
					this.phone.txt="Veuillez saisir un numéro de téléphone correct";
					go=false;
				}else{
					this.phone.error=false;
				}
			}
			if(this.mail.value == ""){
				this.mail.error=true;
				this.mail.txt="Veuillez saisir votre adresse mail";
				go=false;
			}else{
				if(control_inputs.errors.includes("mail")){
					this.mail.error=true;
					this.mail.txt="Veuillez saisir une adresse mail correcte";
					go=false;
				}else{
					this.mail.error=false;
				}
			}
			if(this.naissance.value == ""&&this.sexe.value != "Entreprise"){
				this.naissance.error=true;
				this.naissance.txt="Veuillez saisir votre date de naissance";
				go=false;
			}else{
				this.naissance.error=false;
			}
			if(this.adresse.value == ""){
				this.adresse.error=true;
				this.adresse.txt="Veuillez saisir votre adresse postale";
				go=false;
			}else{
				if(control_inputs.errors.includes("adresse")){
					this.adresse.error=true;
					this.adresse.txt="Veuillez saisir une adresse correcte (sans caractères spéciaux et accents)";
					go=false;
				}else{
					this.adresse.error=false;
				}
			}
			if(this.cp.value == ""){
				this.cp.error=true;
				this.cp.txt="Veuillez saisir votre code postal";
				go=false;
			}else{
				if(control_inputs.errors.includes("cp")){
					this.cp.error=true;
					this.cp.txt="Veuillez saisir une adresse code postal correcte (5 chiffres uniquements)";
					go=false;
				}else{
					this.cp.error=false;
				}
			}
			if(this.ville.value == ""){
				this.ville.error=true;
				this.ville.txt="Veuillez saisir votre ville";
				go=false;
			}else{
				if(control_inputs.errors.includes("ville")){
					this.ville.error=true;
					this.ville.txt="Veuillez saisir une ville correcte (sans chiffres ou caractères spéciaux)";
					go=false;
				}else{
					this.ville.error=false;
				}
			}
			if(this.name_cb.value == ""){
				this.name_cb.error=true;
				this.name_cb.txt="Veuillez saisir le nom qui figure sur la carte bleue qui va procéder au paiement.";
				go=false;
			}else{
				if(control_inputs.errors.includes("name_cb")){
					this.name_cb.error=true;
					this.name_cb.txt="Veuillez saisir un Nom (Figurant sur la carte bleue) correct (sans caractères accentués ou caractères spéciaux)";
					go=false;
				}else{
					this.name_cb.error=false;
				}
			}
			if(this.first_name_cb.value == ""){
				this.first_name_cb.error=true;
				this.first_name_cb.txt="Veuillez saisir le nom qui figure sur la carte bleue qui va procéder au paiement.";
				go=false;
			}else{
				if(control_inputs.errors.includes("first_name_cb")){
					this.first_name_cb.error=true;
					this.first_name_cb.txt="Veuillez saisir un Prénom (Figurant sur la carte bleue) correct (sans caractères accentués ou caractères spéciaux)";
					go=false;
				}else{
					this.first_name_cb.error=false;
				}
			}
			if(go){
				return true;
			}else{
				return false;
			}
		},
		// pay(){
		// 	fb.db.collection('paiements').doc("credit_agricole").get().then(cr_agr => {
		// 		var today = new Date();
		// 		var dateTime = today.toISOString();
		// 		this.$store.dispatch("setInfosPayment",{
		// 			mail:this.mail.value,
		// 			dateTime:dateTime
		// 		}).then(response =>{
		// 			var k1 = cr_agr.data().key_test;
		// 			console.log(k1);
		// 			var key = k1+this.key;
		// 			var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_REPONDRE_A="+this.callback_test+"&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_HASH=SHA512&PBX_TIME="+dateTime;
		// 			var _keyBin = (new Buffer(key, 'hex'));
		// 			var signature = crypto.createHmac('sha512', _keyBin).update(texte, "binary").digest('hex').toUpperCase();
		// 			//var signature = CryptoJS.HmacSHA512(texte,this.key).toString().toUpperCase();
		// 			console.log({date:dateTime,hmac:signature});
		//     		this.date = dateTime;
		//     		this.hmac = signature;
		//     		console.log(this.$refs)
		//     		this.$refs.f2date.value=dateTime;
		//     		this.$refs.f2hmac.value=signature;
		//     		this.show_iframe=true
		//     		this.$refs.f2.submit()
		// 		});
		// 	});
		// },
		pay_out(){
			var today = new Date();
			var dateTime = today.toISOString();
			//console.log(this.callback+this.callback_);
			firebase.auth().signInAnonymously()
      		.then(() => {
				fb.db.collection('paiements').doc("credit_agricole").get().then(cr_agr => {//FAIRE LA MEME CHOSE POUR URL
					this.$store.dispatch("setInfosPayment",this.pay.id).then(response =>{
						/*
						var k1 = cr_agr.data().key;
						// console.log(k1);
						var key = k1+this.key;
						var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_HASH=SHA512&PBX_TIME="+dateTime;
						var _keyBin = (new Buffer(key, 'hex'));
						var signature = crypto.createHmac('sha512', _keyBin).update(texte, "binary").digest('hex').toUpperCase();
						//var signature = CryptoJS.HmacSHA512(texte,this.key).toString().toUpperCase();
						// console.log({date:dateTime,hmac:signature});
			    		this.date = dateTime;
			    		this.hmac = signature;
			    		// console.log(this.$refs)
			    		this.$refs.f22date.value=dateTime;
			    		this.$refs.f22hmac.value=signature;
			    		this.show_iframe=true
			    		this.$refs.f22.submit()
			    		*/

			    		//A CACHER EN PRODUCTION
						//var k1 = cr_agr.data().key_test;
						// // console.log(k1);
						//var key = k1+this.key_test;
						var k1 = cr_agr.data().key;
						// console.log(k1);
						var key = k1+this.key;

						var shop = "<?xml version=\"1.0\" encoding=\"utf-8\"?><shoppingcart><total><totalQuantity>01</totalQuantity></total></shoppingcart>";
						var bill = "<?xml version=\"1.0\" encoding=\"utf-8\"?><Billing><Address><FirstName>"+this.first_name_cb.value+"</FirstName>"+
							"<LastName>"+this.name_cb.value+"</LastName><Address1>"+this.adresse.value+"</Address1>"+
							"<Address2></Address2><ZipCode>"+this.cp.value+"</ZipCode>"+
							"<City>"+this.ville.value+"</City><CountryCode>250</CountryCode>"+
							"</Address></Billing>";
						//this.$refs.f22shop.value = this.escapeHtml(shop);
						//this.$refs.f22bill.value = this.escapeHtml(bill);
						this.$refs.f22shop.value = shop;
						this.$refs.f22bill.value = bill;
						//var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_HASH=SHA512&PBX_TIME="+dateTime+"&PBX_SHOPPINGCART="+this.escapeHtml(shop)+"&PBX_BILLING="+this.escapeHtml(bill);
						var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_HASH=SHA512&PBX_TIME="+dateTime+"&PBX_SHOPPINGCART="+shop+"&PBX_BILLING="+bill;
						var _keyBin = (new Buffer(key, 'hex'));
						var signature = crypto.createHmac('sha512', _keyBin).update(texte, "binary").digest('hex').toUpperCase();
						//var signature = CryptoJS.HmacSHA512(texte,this.key).toString().toUpperCase();
						// console.log({date:dateTime,hmac:signature});
			    		this.date = dateTime;
			    		this.hmac = signature;
			    		// console.log(this.$refs)
			    		this.$refs.f22date.value=dateTime;
			    		this.$refs.f22hmac.value=signature;
			    		this.show_iframe=true
			    		this.$refs.f22.submit()

					});
				});
			});
		},
		pay2(){
			var today = new Date();
			var dateTime = today.toISOString();
				firebase.auth().signInAnonymously()
	      		.then(() => {
					fb.db.collection('paiements').doc("credit_agricole").get().then(cr_agr => {
						fb.db.collection('paiements').add({
							source:"site_web",
							immat:this.$store.state.vehicule.immat,
							email:this.mail.value,
							nom:this.name.value,
							naissance:this.naissance.value,
							sexe:this.sexe.value,
							cp:this.cp.value,
							ville:this.ville.value,
							adresse:this.adresse.value,
							demarche:this.$store.state.vehicule.demarche,
							telephone:this.phone.value,
							date:today,
							taxes:this.$store.state.vehicule.TaxeTotale,
							prestation:this.$store.state.vehicule.Prestation,
							prixTotal:this.$store.state.vehicule.PrixTotal,
							statut:"Initialisé" 
						}).then(docRef =>{
							//console.log(docRef.id)
							this.$store.dispatch("setInfosPayment",docRef.id).then(response =>{

								/*
								//A ACTIVER EN PRODUCTION
								var k1 = cr_agr.data().key;
								// console.log(k1);
								var key = k1+this.key;
								
								//A CACHER EN PRODUCTION
								// var k1 = cr_agr.data().key_test;
								// // console.log(k1);
								// var key = k1+this.key_test;

								// var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_REPONDRE_A="+this.callback_test+"&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_EFFECTUE=http://localhost:8080/paiement&PBX_HASH=SHA512&PBX_TIME="+dateTime;

								//A CACHER EN PRODUCTION
								var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_HASH=SHA512&PBX_TIME="+dateTime;
								var _keyBin = (new Buffer(key, 'hex'));
								var signature = crypto.createHmac('sha512', _keyBin).update(texte, "binary").digest('hex').toUpperCase();
								//var signature = CryptoJS.HmacSHA512(texte,this.key).toString().toUpperCase();
								// console.log({date:dateTime,hmac:signature});
					    		this.date = dateTime;
					    		this.hmac = signature;
					    		// console.log(this.$refs)
					    		this.$refs.f22date.value=dateTime;
					    		this.$refs.f22hmac.value=signature;
					    		this.show_iframe=true
					    		this.$refs.f22.submit()
								*/

								/*
								var texte = 
								"PBX_SITE=3212482"+
								"&PBX_RANG=001"+
								"&PBX_IDENTIFIANT=32429071"+
								"&PBX_SOURCE=RWD"+
								"&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+
								"&PBX_DEVISE=978"+
								"&PBX_CMD="+this.$store.state.vehicule.payment.ref+
								"&PBX_PORTEUR="+this.mail.value+
								"&PBX_TYPEPAIEMENT=CARTE"+
								"&PBX_TYPECARTE=CB&"+
								//"PBX_REPONDRE_A="+this.callback_test+
								"&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K"+
								"&PBX_HASH=SHA512"+
								"&PBX_TIME="+dateTime
								*/

								//A ACTIVER EN PRODUCTION
								//var k1 = cr_agr.data().key;
								// console.log(k1);
								//var key = k1+this.key;
								
								//A CACHER EN PRODUCTION
								//var k1 = cr_agr.data().key_test;
								// // console.log(k1);
								//var key = k1+this.key_test;

								var k1 = cr_agr.data().key;
								// console.log(k1);
								var key = k1+this.key;

								var shop = "<?xml version=\"1.0\" encoding=\"utf-8\"?><shoppingcart><total><totalQuantity>01</totalQuantity></total></shoppingcart>";
								var bill = "<?xml version=\"1.0\" encoding=\"utf-8\"?><Billing><Address><FirstName>"+this.first_name_cb.value+"</FirstName>"+
									"<LastName>"+this.name_cb.value+"</LastName><Address1>"+this.adresse.value+"</Address1>"+
									"<Address2></Address2><ZipCode>"+this.cp.value+"</ZipCode>"+
									"<City>"+this.ville.value+"</City><CountryCode>250</CountryCode>"+
									"</Address></Billing>";

								//this.$refs.f22shop.value = this.escapeHtml(shop);
								//this.$refs.f22bill.value = this.escapeHtml(bill);
								this.$refs.f22shop.value = shop;
								this.$refs.f22bill.value = bill;
									//console.log(this.escapeHtml(shop));
									//console.log(this.escapeHtml(bill));

								//var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_HASH=SHA512&PBX_TIME="+dateTime+"&PBX_SHOPPINGCART="+this.escapeHtml(shop)+"&PBX_BILLING="+this.escapeHtml(bill);
								var texte = "PBX_SITE=3212482&PBX_RANG=001&PBX_IDENTIFIANT=32429071&PBX_SOURCE=RWD&PBX_TOTAL="+this.$store.state.vehicule.payment.amount+"&PBX_DEVISE=978&PBX_CMD="+this.$store.state.vehicule.payment.ref+"&PBX_PORTEUR="+this.mail.value+"&PBX_TYPEPAIEMENT=CARTE&PBX_TYPECARTE=CB&PBX_RETOUR=Mt:M;Ref:R;Auto:A;Erreur:E;sign:K&PBX_HASH=SHA512&PBX_TIME="+dateTime+"&PBX_SHOPPINGCART="+shop+"&PBX_BILLING="+bill;
									//console.log(texte);

								//
								//
								var _keyBin = (new Buffer(key, 'hex'));
								var signature = crypto.createHmac('sha512', _keyBin).update(texte, "binary").digest('hex').toUpperCase();
								var signature_2 = crypto.createHmac('sha512', _keyBin).update(texte).digest('hex').toUpperCase();
								//console.log(texte);
								//console.log(signature);
								//console.log(signature_2);
					    		this.date = dateTime;
					    		this.hmac = signature;
					    		// console.log(this.$refs)
					    		this.$refs.f22date.value=dateTime;
					    		this.$refs.f22hmac.value=signature;
					    		this.show_iframe=true
					    		this.$refs.f22.submit()

					    		
					    		emailjs.send("service_gmpg6hd","template_vbehdpq",{
									name: this.name.value,
									immat: this.$store.state.vehicule.immat,
									phone: this.phone.value,
									email: this.mail.value,
									naissance: this.naissance.value,
									adresse: this.adresse.value,
									cp: this.cp.value,
									ville: this.ville.value,
									demarche: this.$store.state.vehicule.demarche.txt,
									vehicule: this.$store.state.vehicule.Marque+" "+this.$store.state.vehicule.Modele+" "+this.$store.state.vehicule.Version,
									taxes: this.$store.state.vehicule.TaxeTotale,
									presta: this.$store.state.vehicule.Prestation,
									total: this.$store.state.vehicule.PrixTotal
								},"Eowp00T3UWWoXOUds").then(response => {
							       // console.log('SUCCESS!', response.status, response.text);
							    }, error => {
							       // console.log('FAILED...', error);
							    });;
							});
						});
					});
				});
    	},
		command(){
			if(this.$store.state.vehicule.send.type==1){
				if(Object.keys(this.$store.state.vehicule.errors).length>0){
					this.$store.state.vehicule.send={type:3,text:"Je souhaite être recontacté afin de lancer mon dossier"}
					this.$store.state.vehicule.show_form_command = true;
				}else{
					this.$store.state.vehicule.send={type:2,text:"Procéder au paiement"}
					this.$store.state.vehicule.show_form_command = true;
					if(window.innerWidth<"1200"){
						// document.getElementById("page1").classList.add("page1resp");
						// document.getElementById("page2").classList.add("page2resp");
						window.scroll({
						  top: 200,
						  left: 0,
						  behavior: 'smooth'
						});
					}
				}
			}else if(this.$store.state.vehicule.send.type==2){
				var go = this.go()
				if(go){
					this.pay2()
				}else if(window.innerWidth<"1200"){
					window.scroll({
						  top: 200,
						  left: 0,
						  behavior: 'smooth'
					});
				}
			}else if(this.$store.state.vehicule.send.type==3){
				//ENVOIE MAILS A NOUS MEME ET AU CLIENT
			}
		},
		iframeEvent(msg){
			//console.log(msg)
			if(msg.data=="cleanVehicule"){
				this.$store.commit("cleanVehicule");
				// console.log(msg);
			}
			if(msg.data=="initIframe"){
				this.show_iframe=false;
			}
		},
		cleanPay(){
			this.pay.show_inputs=false;
			this.pay.hide_inputs=false;
			this.pay.id="";
			this.mail.value="";
			this.name.value="";
			this.pay.amount="";
			this.pay.demarche="";
			this.pay.immat="";
			this.pay.error_msg="Chargement...";
		},
		fetch_paiement(){
			firebase.auth().signInAnonymously()
      		.then(() => {
				fb.db.collection('paiements').doc(this.$route.query.id).get().then(paiement => {
					var datas=paiement.data();
					// console.log(datas)
					if(this.$route.query.email==datas.email&&this.$route.query.amount==datas.prixTotal&&this.$route.query.id_creator==datas.id_creator&&datas.statut=="Initialisé"){
						fb.db.collection('ppweb_pay').doc(this.$route.query.id_creator).get().then(ppweb_pay => {
	        				if(!ppweb_pay.exists){
								this.pay.show_inputs=true;
								this.pay.hide_inputs=true;
								this.pay.id=this.$route.query.id;
								this.mail.value=datas.email;
								this.name.value=datas.nom;
								this.split_name_f(datas.nom);//MODIFIED
								this.adresse.value=datas.adresse//MODIFIED
								this.cp.value=datas.cp//MODIFIED
								this.ville.value=datas.ville//MODIFIED
								this.pay.amount=datas.prixTotal;
								this.pay.demarche=datas.demarche.txt;
								this.pay.immat=datas.immat;
								this.$store.state.vehicule.PrixTotal=datas.prixTotal;
								this.pay.loading=false;
							}else{
								this.pay.error_msg="ATTENTION ! Cette démarche a déjà été payée. Veuillez vous rapprochez de votre admnisitrateur.";
								setTimeout(()=>{
									this.cleanPay()
									this.pay.loading=false;
									if(this.$route.query.pay=="ppweb"){
										window.location.href = "https://lesrelaiscartegrise.zohocreatorportal.eu/#Mes_d_marches";
									}else if(this.$route.query.pay=="plink"){
										window.location.href = "https://lesrelaiscartegrise.fr";
									}
									
								},4000);
							}
						});
					}else{
						this.pay.error_msg="ATTENTION ! La demande de paiement comporte des erreurs ou n'est pas conforme. Veuillez réessayer.";
						setTimeout(()=>{
							this.cleanPay()
							this.pay.loading=false;
							if(this.$route.query.pay=="ppweb"){
								window.location.href = "https://lesrelaiscartegrise.zohocreatorportal.eu/#Mes_d_marches";
							}else if(this.$route.query.pay=="plink"){
								window.location.href = "https://lesrelaiscartegrise.fr";
							}
						},4000);
					}
				}).catch(error=>{
					this.pay.error_msg="ATTENTION ! La demande de paiement n'a pas pu être identifiée correctement. Veuillez réessayer.";
						setTimeout(()=>{
							this.cleanPay()
							this.pay.loading=false;
							if(this.$route.query.pay=="ppweb"){
								window.location.href = "https://lesrelaiscartegrise.zohocreatorportal.eu/#Mes_d_marches";
							}else if(this.$route.query.pay=="plink"){
								window.location.href = "https://lesrelaiscartegrise.fr";
							}
						},4000);
					return{result:"non_identifiee",datas:error};
				});
			}).catch(error=>{
				this.pay.error_msg="ATTENTION ! La demande de paiement n'a pas pu être identifiée correctement. Veuillez réessayer.";
					setTimeout(()=>{
						this.cleanPay()
						this.pay.loading=false;
						if(this.$route.query.pay=="ppweb"){
							window.location.href = "https://lesrelaiscartegrise.zohocreatorportal.eu/#Mes_d_marches";
						}else if(this.$route.query.pay=="plink"){
							window.location.href = "https://lesrelaiscartegrise.fr";
						}
					},4000);
				});
		}
	},
	mounted(){
		window.addEventListener("message", this.iframeEvent, false);
		// window.addEventListener("init", this.iframeEvent, false);
		if(this.$route.query.pay){
			this.pay.loading=true;
			if((this.$route.query.pay=="ppweb"&&(document.referrer=='https://creatorapp.zoho.eu/'||document.referrer=='https://lesrelaiscartegrise.zohocreatorportal.eu/'))){
				if(this.$route.query.id&&this.$route.query.email&&this.$route.query.amount&&this.$route.query.id_creator){
					this.fetch_paiement();
				}else{
					this.pay.error_msg="ATTENTION ! La requête est incomplète. Veuillez réessayer.";
					setTimeout(()=>{
						this.cleanPay()
						this.pay.loading=false;
						window.location.href = "https://lesrelaiscartegrise.zohocreatorportal.eu/#Mes_d_marches";
					},4000);
				}
			}else if(this.$route.query.pay=="plink"){
				if(this.$route.query.id&&this.$route.query.email&&this.$route.query.amount&&this.$route.query.id_creator){
					this.fetch_paiement();
				}else{
					this.pay.error_msg="ATTENTION ! La requête est incomplète. Veuillez réessayer.";
					setTimeout(()=>{
						this.cleanPay()
						this.pay.loading=false;
						window.location.href = "https://lesrelaiscartegrise.fr";
					},4000);
				}
			}else{
				this.pay.error_msg="ATTENTION ! La requête n'a pas pu être identifiée. Veuillez réessayer.";
				setTimeout(()=>{
					this.cleanPay()
					this.pay.loading=false;
					this.$router.push('/');
				},4000);
			}
		}else{
			this.cleanPay()
		}
		if(this.$route.query.demarche){
			if(this.$route.query.demarche=="01"){
				document.getElementById("demarche").value="01"
			}else if(this.$route.query.demarche=="02"){
				document.getElementById("demarche").value="02"
			}else if(this.$route.query.demarche=="03"){
				document.getElementById("demarche").value="03"
			}else if(this.$route.query.demarche=="04"){
				document.getElementById("demarche").value="04"
			}else if(this.$route.query.demarche=="05"){
				document.getElementById("demarche").value="05"
			}
		}
	},
	beforeDestroy () {
	 	window.removeEventListener("message", this.iframeEvent)
	 	this.show_iframe=false;
	}
}
</script>

<style scoped>
	h1{
		color: black;
	}
	h2{
		text-align:center;
		margin-top: -40px;
		font-weight:400;
		font-size: 1.4em;
	}
	.page{
		display:flex;
		flex-flow:row wrap;
		background-color: #ffffffdd;
		align-items:center;
		justify-content:center;
		padding:40px 0px 40px 0px;
	}
	.div_simulateur{
	}
	.div_vehicule{
		display: flex;
		flex-direction:column;
		align-items:center;
	}
	.arrow{
		width: 100%;
		text-align: center;
	}
	.page1{
		flex: 1.3;
		display:flex;
		flex-direction:column;
		align-items:center;
		justify-content:center;
		padding-left:30px;
		padding-right:10px;
	}
	.page2{
		flex: 2;
	}
	.tarif{
		background-color:#fbfbfb;
		margin-top: 20px;
		padding:5px 15px 15px 15px;
		border-radius:5px;
	}
	.tarif_title{
		padding: 10px;
		text-align: center;
		display:flex;
		align-items:center;
		flex-direction:column;
	}
	.tarif_title h4{
		font-weight: 500;
		max-width:500px;
		text-align:center;
		margin-top:0px;
	}
	.informations{
	display: flex;
	flex-flow: row wrap;
	justify-content:space-between;
}
.informations p{
	margin: 0px;
	padding:0px;
}
.informations > div, .total{
	padding-left: 15px;
	padding-right:15px;
}
.loader2{
	text-align:center;
}
.form_command{
	display:flex;
	flex-direction: column;
	align-items:center;
	justify-content:center;
}
.inputs{
	display: flex;
	justify-content:flex-start;
	align-items:flex-start;
}
.radios{
	min-width: 670px;
}
.radio div{
	margin: 5px;
}
.inputs1, .inputs2{
	padding-top:10px;
	display:flex;
	align-items:center;
	justify-content:center;
	flex-wrap:wrap;
	flex-direction: column;
	margin-left: 25px;
	margin-right: 25px;
}
.input{
	padding-top: 10px;
	padding-bottom:10px;
	margin-left: -10px;
	width:300px;
}

.simu-input {
    text-align: left;
    background-color: #FFFFFF;
	border: 1px solid #b1bcc4;
	border-radius: 4px;
	color: #565656;
	height: 38px;
	width:100%;
	box-shadow: none;
	padding-left:10px;
	padding-right: 5px;
	margin-top:5px;
}
.simu-input:disabled{
	background-color:#b2bec3;
}
.error_input{
	/*background-color: #fab1a0;*/
	border-bottom:6px solid red;
}
.error_txt{
	margin: 0px;
    font-weight:400;
    overflow:auto;
    font-size:1em;
    font-style: italic;
}
.btn_command{
	margin-top: 20px;
}
.btn_command_div{
	display: flex;
	align-items: center;
	justify-content:center;
}
.iframe_div{
	display: flex;
	align-items:center;
	justify-content: center;
}
.iframe{
	background-color:#fbfbfb;
}
.loading_pay{
	background-color:#fbfbfb;
	position:fixed;
	top: 30px;
	left:0;
	height:100%;
	width:100%;
	z-index:100;
	display: flex;
	flex-direction: column;
	justify-content:center;
	align-items:center;
	text-align:center;
}
.lds-dual-ring {
	display:inline-block;
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-left: 5px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 15px;
  height: 15px;
  margin: 0px;
  border-radius: 50%;
  border: 3px solid #999;
  border-color: #999 transparent #999 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media all and (max-width: 1200px) {
	.page{
		flex-direction:column;
		padding:0px;
	}
	.page1{
		/*order: 2;*/
		padding:0px;
		margin: 0px 0px 40px 0px;
	}
	.page2{
		/*order:1;*/
		margin-bottom:30px;
	}
	.page1resp{
		order: 2;
	}
	.page2resp{
		order:1;
	}
	.div_simulateur{
		margin:0px;
	}
	.div_vehicule{
		margin-top: 30px;
	}
	.inputs{
		flex-direction:column;
	}
	.radios{
	min-width:inherit;
	margin-left:50px;
	margin-top:40px;
	}
	.error_txt{
		margin:10px 10px 0px 10px;
		text-align:center;
	}
}

@media all and (max-width: 800px) {
	.tarif_title h4{
		max-width:300px;
	}
	.page1{
		padding:10px;
	}
	.radio{
	}
	.radios{
	min-width:inherit;
	margin-left:20px;
	margin-top:30px;
	}
}

</style>

{
	"webhookTrigger": {
		"payload": {
			"Auto": "XXXXXX",
			"Ref": "ifw7cnhhCPXmXFg157yu",
			"Mt": 13966,
			"Erreur": "00000",
			"sign": "sxiIuN8sfmEUoIekdwjRlXN/z7VpZ2OTRI1w1mIxTAKL777WdmA9aygw9l49QFQbdqiUsNRyQk/KbvuMQHPtXgug+hM/2WuYmnfNTp0eDJNyKtW930ziEpoj2GakByGWpXvYN9eIC1x5dMSTQsZNskJzZTAcJqV1O+ZAaJJNjjA="
		}
	}
}
Document name \"projects/lesrelaiscartegrise-192e7/databases/(default)/documents/paiements/s2d1Ll5gZaaBJD9hqvll/updateMask.fieldPaths=status\


// WEBPACK FOOTER //
// src/components/Go/Immatriculation.vue